import { useState } from 'react';
import BeingProcessed from '@app/components/alerts/BeingProcessed';
import EvaluationExpired from '@app/components/alerts/EvaluationExpired';
import EvaluationSuccessful from '@app/components/alerts/EvaluationSuccessful';
import ServiceAvailability from '@app/components/alerts/ServiceAvailability';
import TryAgainLater from '@app/components/alerts/TryAgainLater';
import { SOLVENCY_DECLARATION_STATUSES } from '@app/configs/solvencyDeclaration';
import { closeExpiredModal, getExpiredModalClosed } from '@modules/borrower/utils/expiredModalManager';
const StatusAlerts = ({ status, goToLoanCreation, tryAgainError, isServiceUnavailable, isRejectedMoreThan14Days, }) => {
    const [isExpiredModalClosed, setIsExpiredModalClosed] = useState(getExpiredModalClosed());
    const handleCloseExpired = () => {
        closeExpiredModal();
        setIsExpiredModalClosed(true);
    };
    if (isServiceUnavailable) {
        return <ServiceAvailability />;
    }
    if (tryAgainError) {
        return <TryAgainLater tryAgainError={tryAgainError}/>;
    }
    switch (status) {
        case SOLVENCY_DECLARATION_STATUSES.approved:
            return <EvaluationSuccessful onProceed={goToLoanCreation}/>;
        case SOLVENCY_DECLARATION_STATUSES.submitted:
            return <BeingProcessed />;
        case SOLVENCY_DECLARATION_STATUSES.expired:
        case SOLVENCY_DECLARATION_STATUSES.to_be_resubmitted:
            if (!isExpiredModalClosed) {
                return <EvaluationExpired onDismiss={handleCloseExpired}/>;
            }
            return null;
        case SOLVENCY_DECLARATION_STATUSES.rejected:
            if (isRejectedMoreThan14Days) {
                return null;
            }
            return <TryAgainLater tryAgainError={tryAgainError}/>;
        default:
            return null;
    }
};
export default StatusAlerts;
